<template>
	<div class="EditReportNav">
		<!-- Retreat button (Cancel, Back, etc.) -->
		<CloButton reverse hollow v-on:click.native="$emit('clicked-retreat')">
			<template v-if="mode === 'create'">{{ $t('generic.Cancel') }}</template>
			<template v-else>{{ $t('generic.Back') }}</template>
		</CloButton>

		<!-- Advance button (Next, save, etc.) -->
		<CloButton color="secondary" :disabled="!advanceable" v-on:click.native="$emit('clicked-advance')">
			<template v-if="mode === 'create'">{{ $t('tripReport.create') }}</template>
			<template v-else-if="view === 'people'">{{ $t('generic.done') }}</template>
			<template v-else>{{ $t('tripReport.saveAndView') }}</template>
		</CloButton>
	</div>
</template>

<script>
import CloButton from '@/base/CloButton/CloButton.vue';
export default {
	name: 'EditReportNav',
	components: {
		CloButton,
	},
	props: {
		mode: String,
		view: String,
		advanceable: Boolean,
		tripId: Number,
		advanceable: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		advanceLabel() {
			let label = this.$t('generic.Save');
			if (this.mode === 'create') {
				label = this.$t('tripReport.create');
			} else {
				if (this.view === 'checklists') {
					label = this.$t('tripReport.create');
				}
			}
			return label;
		},
	},
};
</script>

<style lang="scss">
.EditReportNav .Button {
	margin: 0;
}
.EditReportNav {
	display: flex;
	gap: 1rem;
	justify-content: space-between;
	.Button {
		flex-basis: 50%;
		@include breakpoint(medium) {
			flex-basis: 33%;
		}
	}
}
</style>
